import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import GeomanistRegular from "./assets/Geomanist-Regular.woff2";

let baseTheme = createTheme({
  palette: {
    background: {
      default: "#000", // black
    },
    primary: {
      main: "#A97D58", // Sidebar color
    },
    secondary: {
      main: "#E3E3DC", // Conversation panel color
    },
  },
  typography: {
    fontFamily: ["GeomanistRegular"].join(","),
    button: {
      textTransform: "none",
    },
  },
});

// Extend the theme with component overrides that use the palette
baseTheme = createTheme(baseTheme, {
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'GeomanistRegular';
          src: url(${GeomanistRegular}) format('woff2');
          font-weight: 400;
          font-style: normal;
        }
      `,
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          backgroundColor: baseTheme.palette.primary.main, // row background
        },
        cell: {
          color: "#000", // optional: cell text color
          border: "0.5px solid #000", // row cell borders
        },
      },
    },
  },
});

const mainTheme = responsiveFontSizes(baseTheme);
export default mainTheme;
